import React, { useState } from 'react';
import { Tab, TabGroup, TabList, TabPanel, TabPanels, Grid, Col } from '@tremor/react';
import ParkingMap from '../map/ParkingMap';
import ParkingOverview from '../dashboard/ParkingOverview';
import OccupancyChart from '../charts/OccupancyChart';
import ParkingDistributionChart from '../charts/ParkingDistributionChart';
import VehicleManagement from '../dashboard/VehicleManagement';
import { parkingAreas, parkingStats } from '../../mockData';

const Dashboard: React.FC = () => {
  const [selectedArea, setSelectedArea] = useState<string | null>(null);
  const [showSlots, setShowSlots] = useState<boolean>(false);

  const handleAreaSelect = (areaId: string) => {
    if (selectedArea === areaId) {
      // Toggle slots visibility if clicking on the same area
      setShowSlots(!showSlots);
    } else {
      setSelectedArea(areaId);
      setShowSlots(true);
    }
  };

  const handleSlotSelect = (slotId: string) => {
    console.log(`Slot selected: ${slotId}`);
    // Here you could show a modal with slot details or navigate to a slot detail page
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <TabGroup>
        <TabList className="mb-8">
          <Tab>Overview</Tab>
          <Tab>Parking Map</Tab>
          <Tab>Vehicles</Tab>
        </TabList>
        
        <TabPanels>
          {/* Overview Dashboard */}
          <TabPanel>
            <Grid numItems={1} numItemsMd={2} className="gap-6 mt-6">
              <Col>
                <ParkingOverview stats={parkingStats} />
              </Col>
              <Col>
                <div className="space-y-6">
                  <OccupancyChart stats={parkingStats} />
                  <ParkingDistributionChart stats={parkingStats} />
                </div>
              </Col>
            </Grid>
          </TabPanel>
          
          {/* Parking Map Tab */}
          <TabPanel>
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <h2 className="text-xl font-medium text-contentColor">
                  {selectedArea 
                    ? `Parking Area: ${parkingAreas.find(a => a.id === selectedArea)?.name}` 
                    : 'All Parking Areas'}
                </h2>
                {selectedArea && (
                  <button
                    className="bg-primary text-white px-4 py-2 rounded hover:bg-opacity-90"
                    onClick={() => setSelectedArea(null)}
                  >
                    Back to All Areas
                  </button>
                )}
              </div>
              
              <ParkingMap
                parkingAreas={parkingAreas}
                showSlots={showSlots}
                selectedArea={selectedArea}
                onAreaSelect={handleAreaSelect}
                onSlotSelect={handleSlotSelect}
              />
              
              {selectedArea && (
                <div className="bg-background p-4 rounded-lg">
                  <h3 className="font-semibold text-contentColor">Area Information</h3>
                  {(() => {
                    const area = parkingAreas.find(a => a.id === selectedArea);
                    if (!area) return null;
                    
                    return (
                      <div className="mt-2 grid grid-cols-2 md:grid-cols-4 gap-4">
                        <div>
                          <p className="text-sm text-gray-500">Type</p>
                          <p className='text-contentColor'>{area.type}</p>
                        </div>
                        <div>
                          <p className="text-sm text-gray-500">Capacity</p>
                          <p className='text-contentColor'>{area.capacity} slots</p>
                        </div>
                        <div>
                          <p className="text-sm text-gray-500">Occupied</p>
                          <p className='text-contentColor'>{area.occupied} vehicles</p>
                        </div>
                        <div>
                          <p className="text-sm text-gray-500">Distance</p>
                          <p className='text-contentColor'>{area.distance} km from hotel</p>
                        </div>
                      </div>
                    );
                  })()}
                </div>
              )}
            </div>
          </TabPanel>
          
          {/* Vehicles Tab */}
          <TabPanel>
            <div className="mt-6">
              <VehicleManagement />
            </div>
          </TabPanel>
        </TabPanels>
      </TabGroup>
    </div>
  );
};

export default Dashboard;